
import { tr, locale } from "@/lib/i18n";export const MODULES = [
  { id: "sr-400b", name: "SR Full Black 400 W", power: 400, length: 1722, width: 1134, weight: 21 },
  { id: "sr-430", name: "SR Mono 430 W", power: 430, length: 1722, width: 1134, weight: 21.5 },
  { id: "sr-450", name: "SR Mono 450 W", power: 450, length: 1762, width: 1134, weight: 22 },
  { id: "sr-500", name: "SR Bifacciale 500 W", power: 500, length: 1961, width: 1134, weight: 25.5 },
  { id: "sr-550", name: "SR Mono 550 W", power: 550, length: 2278, width: 1134, weight: 28 },
];

export const REGIONS = [
  "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna", "Friuli-Venezia Giulia", "Lazio",
  "Liguria", "Lombardia", "Marche", "Molise", "Piemonte", "Puglia", "Sardegna", "Sicilia", "Toscana",
  "Trentino-Alto Adige", "Umbria", "Valle d'Aosta", "Veneto",
];

export const COVERINGS = {
  falda: [
    { v: "tegole", l: "Tegole / coppi" },
    { v: "lamiera", l: "Lamiera grecata" },
    { v: "ardesia", l: "Ardesia / scandole" },
    { v: "altro", l: "Altro (vite prigioniera)" },
  ],
  piano: [
    { v: "guaina", l: "Guaina bituminosa" },
    { v: "ghiaia", l: "Ghiaia" },
    { v: "cemento", l: "Cemento / massetto" },
    { v: "pvc", l: "Membrana PVC / TPO" },
  ],
};

export const matchRegion = (state = "") =>
  REGIONS.find((r) => state.toLowerCase().startsWith(r.toLowerCase().slice(0, 5))) || "";

export const getModule = (m = {}) =>
  m.module_id === "custom"
    ? {
        id: "custom",
        name: m.custom?.name || tr("Modulo personalizzato"),
        power: Number(m.custom?.power) || 0,
        length: Number(m.custom?.length) || 0,
        width: Number(m.custom?.width) || 0,
        weight: Number(m.custom?.weight) || 0,
      }
    : MODULES.find((x) => x.id === m.module_id) || MODULES[1];

export const snowMu = (pitch) => (pitch <= 30 ? 0.8 : pitch < 60 ? (0.8 * (60 - pitch)) / 30 : 0);

export const statusKey = (p) => (p.max_step >= 5 ? "Completato" : p.max_step > 1 ? "In corso" : "Bozza");
export const statusOf = (p) => tr(statusKey(p));

export const fmt = (n, d = 2) =>
  Number(n || 0).toLocaleString(locale(), { minimumFractionDigits: d, maximumFractionDigits: d });
